import { BuchungsSaetzeItem } from '@/types/service-response'
import moment from 'moment'

export class ProjectBookingFibu {
  public constructor (
    readonly Datum: string | null,
    readonly Soll: string | null,
    readonly Haben: string | null,
    readonly Kostenstelle: string | null,
    readonly Kostentraeger: string | null,
    readonly BetragFW: string | null, //double
    readonly Waehrung: number | null,
    readonly SteuerBetragFW: string | null, //double
    readonly Steuer: number | null, //double
    readonly Buchungstext: string | null
  ) {}

  static createFromResponse (responseData: BuchungsSaetzeItem[]): Array<ProjectBookingFibu> {
    let result: Array<ProjectBookingFibu> = []
    if (responseData) {
      result = responseData.map((item: BuchungsSaetzeItem) => {
        return new ProjectBookingFibu(
          item.Datum ? moment(item.Datum).format('DD.MM.YYYY') : null,
          item.Soll,
          item.Haben,
          item.Kostenstelle,
          item.Kostentraeger,
          item.BetragFW !== null ? item.BetragFW.toFixed(2) : null,
          item.Waehrung,
          item.SteuerBetragFW !== null ? item.SteuerBetragFW.toFixed(2) : null,
          item.Steuer,
          item.Buchungstext
        )
      })
    }
    return result
  }
}
